<template>
  <div class="options-box" :style="getBtnCss">
    <div v-for="(button, key) in buttons" @click="$emit('click', button.routeName)" :style="nore12" :key="key"
      class="option-button-wrapper">
      <div class="option-button" v-html="button.svg"></div>
      <span> {{ button.name }} </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getFont } from "@/helpers/fonts";
import { useDeviceStatus } from "@/stores/deviceStatus";
import { StyleValue, computed, onBeforeMount, ref, toRefs } from "vue";

defineProps({
  buttons: {
    type: Array<{
      route: string;
      src: string;
      svg: string;
      name: string;
      routeName: string;
    }>,
    required: true,
  },
});
defineEmits<{
  (event: "click", routeName: string): void;
}>();

const nore12 = ref<StyleValue>();
onBeforeMount(async () => {
  nore12.value = (await getFont("nore12")) as StyleValue;
});

const { isWeb } = toRefs(useDeviceStatus());
const getBtnCss = computed(() => {
  if (isWeb.value) {
    return {
      border: "solid var(--worksheet-difficulty-border) 1px",
    };
  }
  return {};
});
</script>

<style scoped>
.options-box {
  position: absolute;
  bottom: 100%;
  right: 100%;
  margin-top: 0.25rem;

  width: max-content;
  min-width: 12rem;
  background-color: #efefef;
  padding: 1rem 1.5rem;
  color: var(--milage-color-primary);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  z-index: 9999;

  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}


.mobile .options-box {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0.25rem;


  width: auto;


  padding: 0.5rem 0.75rem;
  gap: 0.25rem;
}

.option-button-wrapper {
  width: 30%;
  height: auto;
  aspect-ratio: 1 / 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.web .option-button-wrapper {
  width: 4rem;
}

.option-button {
  border-radius: 50%;
  background-color: white;
  border: solid 2px var(--milage-color-primary);

  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
